export const fetchComponentTemplatedResourcesNotDevSafe = ({
  manageSubUrl,
  componentType,
  version,
  isProdEnv,
}) => {
  // react component example
  // <script src="<%= `https://vmx-components.m-anage.com/vmx.jobs-portal/vmx.component.jobs-portal.main.js` %>"></script>
  // <script src="<%= `https://vmx-components.m-anage.com/vmx.jobs-portal/vmx.component.jobs-portal.runtime.js` %>"></script>
  // <script src="<%= `https://vmx-components.m-anage.com/vmx.jobs-portal/vmx.component.jobs-portal.vendors.js` %>"></script>
  if (componentType === 'react') {
    ['main', 'runtime', 'vendors'].forEach((jsBundle) => {
      // script element
      const scriptId = `${manageSubUrl}-resource-${jsBundle}`
      const existingScript = document.getElementById(scriptId)

      if (!existingScript) {
        const src = `https://vmx-components.m-anage.com/${manageSubUrl}.${jsBundle}${isProdEnv ? '' : '.dev'}.js${isProdEnv ? '' : `?v=${Date.now()}`}`
        const script = document.createElement('script')
        script.src = src
        script.id = scriptId
        script.async = true

        document.body.appendChild(script)
      }
    })
  }
  // vue component example
  // <link href="<%= `https://vmx-components.m-anage.com/vmx.user-documents/vmx.component.user-documents.0.0.7.css` %>" rel="stylesheet"></link>
  // <script src="<%= `https://vmx-components.m-anage.com/vmx.user-documents/vmx.component.user-documents.0.0.7.js` %>"></script>
  if (componentType === 'vue') {
    if (!version) {
      throw new Error('please specify a version for the vue component')
    }
    // stylesheet link element
    const linkId = `${manageSubUrl}-resource-link`
    const existingLink = document.getElementById(linkId)

    if (!existingLink) {
      const href = `https://vmx-components.m-anage.com/${manageSubUrl}.${isProdEnv ? version : 'dev'}.css${isProdEnv ? '' : `?v=${Date.now()}`}`
      const link = document.createElement('link')
      link.href = href
      link.id = linkId
      link.rel = 'stylesheet'

      document.head.appendChild(link)
    }
    // script element
    const scriptId = `${manageSubUrl}-resource-script`
    const existingScript = document.getElementById(scriptId)

    if (!existingScript) {
      const src = `https://vmx-components.m-anage.com/${manageSubUrl}.${isProdEnv ? version : 'dev'}.js${isProdEnv ? '' : `?v=${Date.now()}`}`
      const script = document.createElement('script')
      script.src = src
      script.id = scriptId
      script.async = true

      document.body.appendChild(script)
    }
  }
}

export const fetchComponentExternalResourcesNotDevSafe = ({
  manageSubUrl,
  version,
  files,
  isProdEnv,
}) => {
  files.forEach((file) => {
    const { tag, name, ending } = file
    const tagId = `${manageSubUrl}-resource-${tag}-${name}`
    const existingTag = document.getElementById(tagId)
    if (existingTag) {
      return
    }

    const url = `https://vmx-components.m-anage.com/${manageSubUrl}.${name ? `${name}.` : ''}${isProdEnv ? version : 'dev'}.${ending}${isProdEnv ? '' : `?v=${Date.now()}`}`
    const tagElement = document.createElement(tag)
    if (tag === 'link') {
      tagElement.href = url
      tagElement.id = tagId
      tagElement.rel = 'stylesheet'
    } else if (tag === 'script') {
      tagElement.src = url
      tagElement.id = tagId
      tagElement.async = true
    } else {
      throw new Error(`${tag} tag is not supported at the moment`)
    }

    document.body.appendChild(tagElement)
  })
}

// here make the declaration for the env
const isProdEnvGuard = process.env.REACT_APP_ENV === 'production'

export const fetchComponentExternalResources = (args) => {
  const { isProdEnv = true } = args
  let scopedIsProdEnv = isProdEnv
  if (isProdEnvGuard) {
    scopedIsProdEnv = true
  }
  return fetchComponentExternalResourcesNotDevSafe({ isProdEnv: scopedIsProdEnv, ...args })
}

export const fetchComponentTemplatedResources = (args) => {
  const { isProdEnv = true } = args
  let scopedIsProdEnv = isProdEnv
  if (isProdEnvGuard) {
    scopedIsProdEnv = true
  }
  return fetchComponentTemplatedResourcesNotDevSafe({ isProdEnv: scopedIsProdEnv, ...args })
}
